import { createSelector } from '@/factory'
import { constants } from './expressionFinder.constant'

const getHandlers = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.handler }, true)

const getTarget = (value?: string) => createSelector<HTMLElement>({ selector: constants.selector.target, value })

export const expressionFinderSelectors = {
	getHandlers,
	getTarget,
}
